export enum ServerResponseKind {
  SUCCESS,
  ERROR,
}

export interface SuccessResponse<T> {
  kind: ServerResponseKind.SUCCESS;
  response: T;
}

export interface ErrorResponse {
  kind: ServerResponseKind.ERROR;
  response: Error;
}

export type ServerResponse<T> = SuccessResponse<T> | ErrorResponse;

export enum TemplateState {
  SCROLL_LOADING = 'is-loading-scroll',
  LOADING = 'is-loading',
  DISABLED = 'is-disabled',
  ERROR = 'is-error',
  EMPTY = 'is-empty',
  MISSING = 'is-missing-license',
  MISSING_MSP = 'is-missing-msp-license',
  TIMEOUT = 'is-timed-out',
  ENDPOINTS_EMPTY = 'is-endpoints-empty',
  UNAVAILABLE = 'is-unavailable',
}

export enum Keys {
  Enter = 'Enter',
  Escape = 'Escape',
  Up = 'ArrowUp',
  Down = 'ArrowDown',
  Space = ' ',
}

export enum DisplayMode {
  PDF = 'pdf',
  DASHBOARD = 'dashboard',
  REPORT = 'report',
}

/* common font sizes */

// possible values for Title font-weight
export enum FontWeights {
  LIGHT = '300',
  NORMAL = '400',
  MEDIUM = '500',
  SEMIBOLD = '600',
  BOLD = '700',
}

export type FontWeight =
  | FontWeights.LIGHT
  | FontWeights.NORMAL
  | FontWeights.MEDIUM
  | FontWeights.SEMIBOLD
  | FontWeights.BOLD;

// possible values for Title font-size.
export enum FontSizes {
  PARAGRAPH_10 = '10',
  PARAGRAPH_11 = '11',
  PARAGRAPH_12 = '12',
  PARAGRAPH_13 = '13',
  HEADING_6 = '14',
  HEADING_5 = '16',
  HEADING_4 = '18',
  BODY = '20',
  TITLE = '22',
  HEADING_3 = '24',
  HEADING_2 = '32',
  HEADING_1 = '36',
  DISPLAY = '48',
}

export type FontSize =
  | FontSizes.PARAGRAPH_11
  | FontSizes.PARAGRAPH_12
  | FontSizes.PARAGRAPH_13
  | FontSizes.HEADING_6
  | FontSizes.HEADING_5
  | FontSizes.HEADING_4
  | FontSizes.BODY
  | FontSizes.TITLE
  | FontSizes.HEADING_3
  | FontSizes.HEADING_2
  | FontSizes.HEADING_1
  | FontSizes.DISPLAY;

// possible values for Text line-height
export enum LineHeights {
  SMALL = '1.2',
  NORMAL = '1.5',
  BIG = '2',
}

export type LineHeight = LineHeights.SMALL | LineHeights.NORMAL | LineHeights.BIG;

// possible values for Dropdown / Dropdown Menu Label sizes
export enum LabelWidthValues {
  SMALL = '80',
  MEDIUM = '160',
  LARGE = '240',
  XLARGE = '320',
  XXLARGE = '400',
  FULL = 'full',
  AUTO = 'auto',
}

export type LabelWidth =
  | LabelWidthValues.SMALL
  | LabelWidthValues.MEDIUM
  | LabelWidthValues.LARGE
  | LabelWidthValues.FULL;

// possible values for Dropdown / Dropdown Menu menu alignment
export enum MenuPosition {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

// possible values for ResizeDirection
export enum ResizeDirection {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}

// generic constructor helper for mixins, that ensures the superClass passed to the mixin extends from a certain
// class, i.e. LitElement or HTMLElement.
export type Constructor<T> = new (...args: any[]) => T;
